const isResellerConnected = () =>
  !!window.localStorage.getItem('isResellerConnected') || false;

export {
  isResellerConnected,
};
